<template>
    <div id="public_Loading">
        <ul class="loading">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ul>
    </div>
</template>
<style type="text/css" lang='less' scoped>
    #public_Loading {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 99999999;
        display: none;
        /*background: rgba(255,255,255,0.4);*/
        background: rgba(0,0,0,0.4);
       .loading{
            position: absolute;
            width: 200px;
            height: 200px;
            left: 50%;
            top: 50%;
            margin-left: -100px;
            margin-top: -100px;
           li{
               position: absolute;
               left: 50%;
               margin-left: -5px;
               top: 40px;
               width: 10px;
               height:26px;
               background-image: url("../../assets/newceping/load2.png");
               background-size: 100% 100%;
               transform-origin:50% 60px;
           }
           li:nth-of-type(1){
                transform: rotate(30deg);
           }
           li:nth-of-type(2){
               transform: rotate(60deg);
           }
           li:nth-of-type(3){
               transform: rotate(90deg);
           }
           li:nth-of-type(4){
               transform: rotate(120deg);
           }
           li:nth-of-type(5){
               transform: rotate(150deg);
           }
           li:nth-of-type(6){
               transform: rotate(180deg);
           }
           li:nth-of-type(7){
               transform: rotate(210deg);
           }
           li:nth-of-type(8){
               transform: rotate(240deg);
           }
           li:nth-of-type(9){
               transform: rotate(270deg);
           }
           li:nth-of-type(10){
               transform: rotate(300deg);
           }
           li:nth-of-type(11){
               transform: rotate(330deg);
           }
           li:nth-of-type(12){
               transform: rotate(360deg);
           }
        }
    }
</style>
<script>
import load1 from '../../assets/newceping/load1.png'
import load2 from '../../assets/newceping/load2.png'
export default {
    data() {
        return {
            number:0
        }
    },
    methods: {
        load(number){
            if(number>12){
                $('#public_Loading  .loading li').css('backgroundImage','url('+load2+')')
                this.number=0;
               return;
            }
            $('#public_Loading  .loading li').eq(number).css('backgroundImage','url('+load1+')')
            this.number++;
        }
    },
    watch: {

    },
    mounted() {
        // var width = $('body,html').width();
        // var height = $('body,html').height();
        // $("#public_Loading").css({width:width,height:height})
        setInterval(function () {
            var num = this.number
            this.load(num)
        }.bind(this),100)

    },
    created() {

    }
}
</script>